import promis from './promis'
import API from '@/api/index'
import Vue from 'vue'
import tool from '@/utils/tool'

/* eslint-disable */

export default {
	getHomeData: function (codelist) {
		return promis.get1(API.Homeapi + codelist)
	},
	postHomeData: function (url, params) {
		return promis.post(API.Homeapi + url, params)
	},
	deleteHomeData: function (url, params) {
		return promis.delete(API.Homeapi + url, params)
	},
	getCodeNewData: function (codelist, jsCallback, fun) {
		// 名称|最新|幅度|代码|
		var par = {
			action: '60',
			MaxCount: '6000',
			StartPos: '0',
			StockIndex: '9',
			NeedCheck: '1|2|4|32',
			Lead: '1',
			AccountIndex: '0',
			Direction: '1',
			Grid: codelist
		}
		tool.getZfthq('60', par, jsCallback, (res) => {
			fun && fun(res)
		},() => {
			promis.post2(API.Codeapi + '/reqxml?', par).then(res => {
				fun && fun(res)
			})
		})
	},
	getCodeOneData: function (codelist, sort, order, jsCallback, fun) {
		// 名称|最新|幅度|代码|
		var par = {
			action: '60',
			MaxCount: '6000',
			StartPos: '0',
			StockIndex: '9',
			NeedCheck: '1|2|4|32|232',
			Lead: '1',
			AccountIndex: sort.toString(),
			Direction: order.toString(),
			Grid: codelist
		}
		tool.getZfthq('60', par, jsCallback, (res) => {
			fun && fun(res)
		},() => {
			promis.post2(API.Codeapi + '/reqxml?', par).then(res => {
				fun && fun(res)
			})
		})
	},
	postEvidenceData: function (params) {
		return promis.post(API.Homeapi + '/evidence/save', params)
	},
	getSignData: function (params) {
		return promis.post3(API.alreadyReadSign + params, '')
	},
	querySignData: function (params) {
		return promis.querySign(API.queryReadSign + params, '')
	},
	collectInfoData: function (params) {
		return promis.post(API.collectInfo, params)
	},
	cancelCollectInfoData: function (params) {
		return promis.delete(API.cancelCollectInfo, params)
	},
	queryCollectInfoData: function (url) {
		return promis.post(API.queryCollectInfo + url, '')
	},
	getsskxData: function (url, params) {
		return promis.get1(API.sskxApi + url, params)
	},
	getTdxData: function (url, params) {
		return promis.post4(API.tdxzxApi + url, params)
	},
	getNewsData: function (url, params, nowTime) {
		var headers = {
			appName: API.appName,
			appVersion: API.appVersion,
			userId: localStorage.getItem('ZFT_tztudid'),
			authorization: localStorage.getItem('ZFT_authorization'),
			touristId: localStorage.getItem('ZFTZX_touristId'),
			phone: localStorage.getItem('ZFTZX_mobilecode'),
			userCode: localStorage.getItem('ZFTZX_userCode'),
			nowTime: nowTime || new Date().getTime()
		}
		return promis.getNews(API.digitinfo + url, params, headers)
	},
	postNewsData: function (url, params, nowTime) {
		if (url === '/api/v1/info-plat-service/attention/follow' || url === '/api/v1/info-plat-service/attention/unfollow'
		|| url === '/api/v1/info-plat-service/timeline/collectionInformation' || url === '/api/v1/info-plat-service/timeline/likeiInformation' || url === '/api/v1/info-plat-service/timeline/collectionInformationForMsgId') {
			if (!localStorage.getItem('ZFTZX_mobilecode')) {
				(new Vue).$bus.$emit('goTomobilecode')
				return new Promise((resolve, reject) => {
					reject(400)
				})
			}
		}
		var headers = {
			appName: API.appName,
			appVersion: API.appVersion,
			userId: localStorage.getItem('ZFT_tztudid'),
			authorization: localStorage.getItem('ZFT_authorization'),
			touristId: localStorage.getItem('ZFTZX_touristId'),
			phone: localStorage.getItem('ZFTZX_mobilecode'),
			userCode: localStorage.getItem('ZFTZX_userCode'),
			nowTime: nowTime || new Date().getTime()
		}
		return promis.postNews(API.digitinfo + url, params, headers)
	},
	getdstxNewData: function (url, params) {
		return promis.post4(API.dstxapi + url, params)
	},
	getxgxzNewData: function (url, params) {
		return promis.get1(API.xgxz + url, params)
	},
	getzxData: function (url, params) {
		return promis.post(API.zxapi + url, params)
	},
	getbaseData: function (url, params) {
		return promis.get1(API.baseapi + url, params)
	},
	postReqXml: function (action, url, params, jsCallback, fun) {
		tool.getZfthq(action, params, jsCallback, (res) => {
			fun && fun(res)
		}, () => {
			promis.post2(API.Codeapi + url, params).then(res => {
				fun && fun(res)
			})
		})
	}
}

/* eslint-enable */



// WEBPACK FOOTER //
// ./src/servers/postageMgr.js